document.addEventListener('DOMContentLoaded', function () {
  var nw_carousels = document.querySelectorAll('.nw-main-carousel');
  if (!nw_carousels.length) return;

  var resizeNwTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeNwTimer);
    resizeNwTimer = setTimeout(initNwCarousels, 250);
  });

  function initNwCarousels() {
    nw_carousels.forEach(function (carousel) {
      if (carousel.flickityInstance) {
        carousel.flickityInstance.destroy();
      }

      var groupCellsValue;
      var windowWidth = window.innerWidth;
      var blogSlider = carousel.querySelector('.carousel-cell-blog') !== null;

      if (windowWidth >= 62.0625 * 16) {
        // 62.0625rem in pixels
        if (blogSlider) {
          groupCellsValue = 3;
        } else {
          groupCellsValue = 4;
        }
      } else if (windowWidth >= 41.4375 * 16) {
        // 41.4375rem in pixels;
        if (blogSlider) {
          groupCellsValue = 2;
        } else {
          groupCellsValue = 3;
        }
      } else if (windowWidth >= 26.3125 * 16) {
        // 26.3125rem in pixels
        if (blogSlider) {
          groupCellsValue = 2;
        } else {
          groupCellsValue = 2;
        }
      } else {
        if (blogSlider) {
          groupCellsValue = 1;
        } else {
          groupCellsValue = 1; // default for smaller screens
        }
      }

      carousel.flickityInstance = new Flickity(carousel, {
        cellAlign: 'center',
        contain: true,
        groupCells: groupCellsValue,
        prevNextButtons: true,
        pageDots: true,
        draggable: true,
        freeScroll: false,
        resize: true,
      });

      if (carousel.classList.contains('title-below-image')) {
        nw_set_slides_height(carousel);
      }
    });
  }
  function nw_set_slides_height(carousel) {
    var max_title_height = 0;
    var titles = carousel.querySelectorAll('.carousel-cell-title');

    titles.forEach(function (title) {
      var title_height = title.offsetHeight;
      if (title_height > max_title_height) {
        max_title_height = title_height;
      }
    });
    var flickity_viewport = carousel.querySelector('.flickity-viewport');
    if (flickity_viewport) {
      flickity_viewport.style.height = carousel.flickityInstance.maxCellHeight + max_title_height + 'px';
    }
    var slider_images = carousel.querySelectorAll('.nw-carousel-image');
    slider_images.forEach(function (image) {
      image.style.height = carousel.flickityInstance.maxCellHeight + 'px';
    });
    var carousel_cells = carousel.querySelectorAll('.carousel-call__wrapper');
    carousel_cells.forEach(function (cell) {
      cell.style.height = carousel.flickityInstance.maxCellHeight + max_title_height + 'px';
    });
  }
  initNwCarousels();
});

class SampleLimitValidator {
  static DEFAULT_LIMITS = {
    total: 6,
    largePerProduct: 1,
    fullPerProduct: 3,
  };

  constructor(popupElement) {
    this.popup = popupElement;
    this.config = this.loadConfig();
    this.limits = { ...SampleLimitValidator.DEFAULT_LIMITS, ...(this.config.limits || {}) };
  }

  loadConfig() {
    const configEl = document.getElementById('sample-limit-popup-config') || this.popup?.previousElementSibling;

    if (!configEl || configEl.id !== 'sample-limit-popup-config') {
      return { limits: { ...SampleLimitValidator.DEFAULT_LIMITS }, messages: {} };
    }

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      console.error('[SampleLimitPopup] Invalid config JSON.', error);
      return { limits: { ...SampleLimitValidator.DEFAULT_LIMITS }, messages: {} };
    }
  }

  getMessage(reason) {
    return this.config.messages?.[reason];
  }

  isSampleItem(sku, title) {
    const skuUp = String(sku || '').toUpperCase();
    const titleUp = String(title || '').toUpperCase();
    return skuUp.includes('SAMPLE') || skuUp.includes('LARGE') || skuUp.includes('FULL') || titleUp.includes('SAMPLE');
  }

  resolveProductHandle(item) {
    if (item?.handle) return item.handle;
    const match = String(item?.url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : undefined;
  }

  getSampleType(sku, title, variantTitle) {
    const combined = `${sku || ''} ${title || ''} ${variantTitle || ''}`.toUpperCase();
    if (combined.includes('LARGE')) return 'large';
    if (combined.includes('FULL')) return 'full';
    return 'standard';
  }

  summarizeCartSamples(items, excludeKey) {
    let totalQty = 0;
    const byHandle = {};

    (items || []).forEach((item) => {
      if (!this.isSampleItem(item.sku, item.title)) return;
      if (excludeKey && item.key === excludeKey) return;

      const handle = this.resolveProductHandle(item);
      const type = this.getSampleType(item.sku, item.title, item.variant_title);

      totalQty += item.quantity;

      if (!byHandle[handle]) {
        byHandle[handle] = { large: 0, full: 0, standard: 0, total: 0 };
      }

      byHandle[handle][type] += item.quantity;
      byHandle[handle].total += item.quantity;
    });

    return { totalQty, byHandle };
  }

  validate(cart, options) {
    const items = cart?.items || [];

    if (options.itemKey != null && options.newQty != null) {
      const item = items.find((cartItem) => cartItem.key === options.itemKey);
      if (!item || !this.isSampleItem(item.sku, item.title)) {
        return { allowed: true };
      }

      if (options.newQty <= item.quantity) {
        return { allowed: true };
      }

      const productHandle = this.resolveProductHandle(item);
      const sampleType = options.sampleType || this.getSampleType(item.sku, item.title, item.variant_title);
      const summary = this.summarizeCartSamples(items, null);
      const newTotal = summary.totalQty - item.quantity + options.newQty;

      if (newTotal > this.limits.total) {
        return { allowed: false, reason: 'total_samples' };
      }

      const productCounts = summary.byHandle[productHandle] || {
        large: 0,
        full: 0,
        standard: 0,
        total: 0,
      };
      const newTypeQty = productCounts[sampleType] - item.quantity + options.newQty;

      if (sampleType === 'large' && newTypeQty > this.limits.largePerProduct) {
        return { allowed: false, reason: 'large_per_product' };
      }
      if (sampleType === 'full' && newTypeQty > this.limits.fullPerProduct) {
        return { allowed: false, reason: 'full_per_product' };
      }

      return { allowed: true };
    }

    const productHandle = options.productHandle;
    const sampleType = options.sampleType || 'standard';
    const additionalTotal = options.quantity || 1;
    const summary = this.summarizeCartSamples(items, null);
    const newTotal = summary.totalQty + additionalTotal;

    if (newTotal > this.limits.total) {
      return { allowed: false, reason: 'total_samples' };
    }

    const productCounts = summary.byHandle[productHandle] || {
      large: 0,
      full: 0,
      standard: 0,
      total: 0,
    };

    if (sampleType === 'large') {
      if (productCounts.large + additionalTotal > this.limits.largePerProduct) {
        return { allowed: false, reason: 'large_per_product' };
      }
    } else if (sampleType === 'full') {
      if (productCounts.full + additionalTotal > this.limits.fullPerProduct) {
        return { allowed: false, reason: 'full_per_product' };
      }
    }

    return { allowed: true };
  }
}

class SampleLimitPopup extends HTMLElement {
  static CLOSE_DURATION_MS = 250;
  static SCROLL_LOCK_CLASS = 'js-sample-limit-popup-open';

  connectedCallback() {
    this.validator = new SampleLimitValidator(this);
    this.dialog = this.querySelector('dialog');
    this.titleEl = this.querySelector('[data-popup-title]');
    this.bodyEl = this.querySelector('[data-popup-body]');
    this.closeBtn = this.querySelector('[data-popup-close]');
    this.isClosing = false;

    this.onValidate = this.onValidate.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onDialogClick = this.onDialogClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onKeyup = this.onKeyup.bind(this);

    document.addEventListener('sample-limit:validate', this.onValidate);
    document.addEventListener('sample-limit-popup:open', this.onOpen);
    this.closeBtn?.addEventListener('click', this.onClose);
    this.dialog?.addEventListener('click', this.onDialogClick);
    this.dialog?.addEventListener('cancel', this.onCancel);
    window.addEventListener('keydown', this.onKeydown, true);
    window.addEventListener('keyup', this.onKeyup, true);
  }

  disconnectedCallback() {
    document.removeEventListener('sample-limit:validate', this.onValidate);
    document.removeEventListener('sample-limit-popup:open', this.onOpen);
    this.closeBtn?.removeEventListener('click', this.onClose);
    this.dialog?.removeEventListener('click', this.onDialogClick);
    this.dialog?.removeEventListener('cancel', this.onCancel);
    window.removeEventListener('keydown', this.onKeydown, true);
    window.removeEventListener('keyup', this.onKeyup, true);
    this.unlockScroll();
  }

  lockScroll() {
    document.documentElement.classList.add(SampleLimitPopup.SCROLL_LOCK_CLASS);
  }

  unlockScroll() {
    document.documentElement.classList.remove(SampleLimitPopup.SCROLL_LOCK_CLASS);
  }

  onValidate(event) {
    const { cart, options } = event.detail || {};
    const result = this.validator.validate(cart, options);
    event.detail.allowed = result.allowed;
    event.detail.reason = result.reason;
  }

  onOpen(event) {
    const { reason } = event.detail || {};
    const message = this.validator.getMessage(reason);

    if (!message?.title || !message?.body) {
      console.warn('[SampleLimitPopup] Missing copy for reason:', reason);
      return;
    }

    if (!this.dialog) return;

    this.titleEl.innerHTML = message.title;
    this.bodyEl.innerHTML = message.body;
    this.dialog.showModal();
    this.lockScroll();
    this.closeBtn?.focus();
  }

  onClose(event) {
    event?.stopPropagation();

    if (!this.dialog?.open || this.isClosing) return;

    this.isClosing = true;
    this.dialog.classList.add('sample-limit-popup__dialog--closing');

    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : SampleLimitPopup.CLOSE_DURATION_MS;

    window.setTimeout(() => {
      this.dialog.classList.remove('sample-limit-popup__dialog--closing');
      this.dialog.close();
      this.unlockScroll();
      this.isClosing = false;
    }, duration);
  }

  onCancel(event) {
    event.preventDefault();
    event.stopPropagation();
    this.onClose(event);
  }

  onDialogClick(event) {
    event.stopPropagation();

    if (event.target === this.dialog) {
      this.onClose(event);
    }
  }

  onKeydown(event) {
    if (!this.dialog?.open || event.key !== 'Escape') return;

    event.preventDefault();
    event.stopPropagation();
    this.onClose(event);
  }

  onKeyup(event) {
    if (event.key !== 'Escape') return;
    if (!this.dialog?.open && !this.isClosing) return;

    event.preventDefault();
    event.stopPropagation();
  }
}

if (!customElements.get('sample-limit-popup')) {
  customElements.define('sample-limit-popup', SampleLimitPopup);
}

// Native theme interactions.
(() => {
  const productHoverSelector = '.nw-has-hover-image';
  const trustpilotWidgetSelector = '.nw-trustpilot-product-mini-widget';
  const trustpilotObservers = new WeakMap();
  const revealedTrustpilotTitles = new WeakSet();
  const tabStates = new WeakMap();
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getClosestElement(target, selector) {
    return target instanceof Element ? target.closest(selector) : null;
  }

  function setActiveProductHover(activeItem) {
    document.querySelectorAll(`${productHoverSelector}.active`).forEach((item) => {
      if (item !== activeItem) {
        item.classList.remove('active');
      }
    });

    activeItem.classList.add('active');
  }

  function handleProductPointerOver(event) {
    const item = getClosestElement(event.target, productHoverSelector);

    if (!item || (event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) {
      return;
    }

    setActiveProductHover(item);
  }

  function handleProductPointerOut(event) {
    const item = getClosestElement(event.target, productHoverSelector);

    if (!item || (event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) {
      return;
    }

    item.classList.remove('active');
  }

  function handleProductTouchMove(event) {
    const item = getClosestElement(event.target, productHoverSelector);

    if (item) {
      setActiveProductHover(item);
    }
  }

  function resetTabContentStyles(contents) {
    contents.forEach((content) => {
      content.style.removeProperty('opacity');
      content.style.removeProperty('display');
    });
  }

  function setActiveTabContent(contents, activeContent) {
    contents.forEach((content) => {
      content.classList.toggle('active', content === activeContent);
    });
  }

  function cancelTabAnimations(state, contents) {
    state.animations.forEach((animation) => animation.cancel());
    state.animations = [];
    resetTabContentStyles(contents);
  }

  function waitForAnimation(animation) {
    return animation.finished.catch(() => null);
  }

  async function switchTabContent(container, activeContent, targetContent) {
    const contents = Array.from(container.querySelectorAll('.tab-content'));
    const state = tabStates.get(container) || { version: 0, animations: [] };
    const version = state.version + 1;

    state.version = version;
    cancelTabAnimations(state, contents);
    tabStates.set(container, state);

    if (
      !activeContent ||
      activeContent === targetContent ||
      reduceMotionQuery.matches ||
      typeof activeContent.animate !== 'function'
    ) {
      setActiveTabContent(contents, targetContent);
      return;
    }

    const fadeOut = activeContent.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      easing: 'linear',
      fill: 'forwards',
    });

    state.animations.push(fadeOut);
    await waitForAnimation(fadeOut);

    if (state.version !== version) {
      return;
    }

    fadeOut.cancel();
    state.animations = [];
    activeContent.classList.remove('active');
    targetContent.classList.add('active');

    const fadeIn = targetContent.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      easing: 'linear',
      fill: 'forwards',
    });

    state.animations.push(fadeIn);
    await waitForAnimation(fadeIn);

    if (state.version !== version) {
      return;
    }

    fadeIn.cancel();
    state.animations = [];
    resetTabContentStyles(contents);
  }

  function handleTabClick(event) {
    const button = getClosestElement(event.target, '.nw-tab-container .tab-button');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.classList.contains('active')) {
      return;
    }

    const container = button.closest('.nw-tab-container');
    const targetName = button.dataset.tab;
    const targetContent = Array.from(container.querySelectorAll('.tab-content')).find(
      (content) => content.dataset.tab === targetName
    );

    if (!targetContent) {
      return;
    }

    const activeContent = container.querySelector('.tab-content.active');

    container.querySelectorAll('.tab-button').forEach((tabButton) => {
      tabButton.classList.toggle('active', tabButton === button);
    });

    const tabWrap = container.querySelector('.tab-wrap');
    if (tabWrap) {
      tabWrap.classList.toggle('active', targetName === 'tab-style');
    }

    switchTabContent(container, activeContent, targetContent);
  }

  function revealTrustpilotTitles() {
    document.querySelectorAll('.trustpilot-reviews-title').forEach((title) => {
      if (revealedTrustpilotTitles.has(title)) {
        return;
      }

      revealedTrustpilotTitles.add(title);
      title.style.display = 'block';

      if (!reduceMotionQuery.matches && typeof title.animate === 'function') {
        title.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 200,
          easing: 'linear',
        });
      }
    });
  }

  function updateTrustpilotMiniWidget(container) {
    const isLoaded = container.querySelectorAll('iframe').length >= 2;
    const section = container.closest('.trustpilot-reviews');

    if (section) {
      section.classList.toggle('active', isLoaded);
    }

    if (isLoaded) {
      revealTrustpilotTitles();
    }

    return isLoaded;
  }

  function observeTrustpilotMiniWidget(container) {
    const existingObserver = trustpilotObservers.get(container);

    if (updateTrustpilotMiniWidget(container)) {
      if (existingObserver) {
        existingObserver.disconnect();
        trustpilotObservers.delete(container);
      }
      return;
    }

    if (existingObserver) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (updateTrustpilotMiniWidget(container)) {
        observer.disconnect();
        trustpilotObservers.delete(container);
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
    trustpilotObservers.set(container, observer);
  }

  function findElements(root, selector) {
    const elements = [];

    if (root instanceof Element && root.matches(selector)) {
      elements.push(root);
    }

    if (root instanceof Document || root instanceof Element) {
      elements.push(...root.querySelectorAll(selector));
    }

    return elements;
  }

  function checkTrustpilotMiniWidgets(root = document) {
    findElements(root, trustpilotWidgetSelector).forEach(observeTrustpilotMiniWidget);
  }

  function refreshTrustpilot(root = document) {
    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
      findElements(root, '.trustpilot-widget').forEach((widget) => {
        window.Trustpilot.loadFromElement(widget);
      });
    }

    checkTrustpilotMiniWidgets(root);
  }

  function ensureMediaPopup() {
    let popup = document.getElementById('nw-media-popup-box-container');

    if (popup) {
      return popup;
    }

    popup = document.createElement('div');
    popup.id = 'nw-media-popup-box-container';
    popup.innerHTML =
      '<div class="nw-media-popup-box-inner"></div><div class="popup-bg close-popup"></div>';
    document.body.appendChild(popup);

    return popup;
  }

  function clearMediaPopupClose(popup) {
    if (popup._pglDrawerCloseTimer != null) {
      window.clearTimeout(popup._pglDrawerCloseTimer);
      popup._pglDrawerCloseTimer = null;
    }

    if (popup._pglDrawerCloseHandler) {
      const panel = popup.querySelector('.nw-media-popup-box-inner');
      panel?.removeEventListener('transitionend', popup._pglDrawerCloseHandler);
      popup._pglDrawerCloseHandler = null;
    }
  }

  function prepareMediaPopupTransition(popup, callback) {
    // Keep the popup's flex layout; theme.utils.prepareTransition adds a class
    // that changes display to block and shifts this drawer to the left.
    popup.offsetWidth;
    callback();
  }

  function openMediaPopup(button) {
    const section = button.closest('.nw-media-related-products-section');
    const source = section ? section.querySelector('.nw-media-related-products-container') : null;

    if (!source) {
      return;
    }

    const popup = ensureMediaPopup();
    const popupContent = popup.querySelector('.nw-media-popup-box-inner');

    if (!popupContent) {
      return;
    }

    if (
      popup._pglOpenButton === button &&
      popup.classList.contains('active')
    ) {
      return;
    }

    const isClosing = popup.classList.contains('pgl-featured-products-drawer--closing');
    const isDrawerMounted = popup.classList.contains('pgl-featured-products-drawer');
    const isDrawerOpen = isDrawerMounted && popup.classList.contains('active');

    clearMediaPopupClose(popup);
    popup._pglOpenButton = button;
    popup.classList.remove('pgl-featured-products-drawer--closing');

    const isLightboxContext = document.body.classList.contains('pgl-lightbox-open');
    popup.classList.add('pgl-featured-products-drawer');
    if (!isDrawerMounted) {
      popup.classList.add('pgl-featured-products-drawer--preparing');
      popup.classList.remove('active');
    }

    popupContent.innerHTML = source.innerHTML;
    const popupHeader = popupContent.querySelector('.nw-media-related-products-header');
    const popupList = popupContent.querySelector('.nw-media-related-products-list');

    popupHeader?.classList.add('appear-animation', 'appear-delay-1');
    popupList?.classList.add('appear-animation', 'appear-delay-2');

    if (isLightboxContext) {
      const popupTitle = popupContent.querySelector('.popup-title');
      const featuredTitle = popupHeader?.dataset.featuredTitle;
      if (popupTitle && featuredTitle) {
        popupTitle.textContent = featuredTitle;
      }
    }
    document.body.classList.add('nw-lock-scroll');

    if (!isDrawerMounted && !isClosing) {
      popupContent.offsetWidth;
      popup.classList.remove('pgl-featured-products-drawer--preparing');
      popupContent.offsetWidth;
    } else {
      popup.classList.remove('pgl-featured-products-drawer--preparing');
    }

    if (isClosing && !isDrawerOpen) {
      popup.classList.add('active');
    } else if (!isDrawerOpen) {
      prepareMediaPopupTransition(popup, () => popup.classList.add('active'));
    }
  }

  function closeMediaPopup() {
    const popup = document.getElementById('nw-media-popup-box-container');

    if (!popup) {
      document.body.classList.remove('nw-lock-scroll');
      return;
    }

    const isLightboxDrawer = popup.classList.contains('pgl-featured-products-drawer');
    if (!isLightboxDrawer) {
      popup.classList.remove('active');
      document.body.classList.remove('nw-lock-scroll');
      return;
    }

    popup._pglOpenButton = null;

    const shouldWaitForTransition = popup.classList.contains('active');

    const finishClose = () => {
      clearMediaPopupClose(popup);
      popup.classList.remove('pgl-featured-products-drawer--closing');
      document.body.classList.remove('nw-lock-scroll');
    };

    if (!shouldWaitForTransition) {
      if (popup.classList.contains('pgl-featured-products-drawer--closing')) {
        return;
      }

      clearMediaPopupClose(popup);
      finishClose();
      return;
    }

    popup.classList.add('pgl-featured-products-drawer--closing');
    const panel = popup.querySelector('.nw-media-popup-box-inner');
    popup._pglDrawerCloseHandler = (event) => {
      if (
        event.target === panel &&
        event.propertyName === 'transform'
      ) {
        finishClose();
      }
    };
    panel?.addEventListener('transitionend', popup._pglDrawerCloseHandler);
    prepareMediaPopupTransition(popup, () => popup.classList.remove('active'));
    popup._pglDrawerCloseTimer = window.setTimeout(finishClose, 500);
  }

  function handleMediaPopupClick(event) {
    const openButton = getClosestElement(event.target, '.nw-media-related-product-button');

    if (openButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openMediaPopup(openButton);
      return;
    }

    const closeButton = getClosestElement(event.target, '.close-popup');
    const popup = document.getElementById('nw-media-popup-box-container');

    if (closeButton && popup && popup.contains(closeButton)) {
      event.preventDefault();
      closeMediaPopup();
    }
  }

  function handleMediaPopupKeydown(event) {
    const popup = document.getElementById('nw-media-popup-box-container');

    if (event.key === 'Escape' && popup && popup.classList.contains('active')) {
      const isLightboxDrawer = popup.classList.contains('pgl-featured-products-drawer');
      closeMediaPopup();
      if (isLightboxDrawer) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }

  function initialize() {
    document.addEventListener('pointerover', handleProductPointerOver);
    document.addEventListener('pointerout', handleProductPointerOut);
    document.addEventListener('touchmove', handleProductTouchMove, { passive: true });
    document.addEventListener('click', handleTabClick);
    document.addEventListener('click', handleMediaPopupClick);
    document.addEventListener('keydown', handleMediaPopupKeydown);
    document.addEventListener('collection:reloaded', () => refreshTrustpilot());
    document.addEventListener('shopify:section:load', (event) => refreshTrustpilot(event.target));

    checkTrustpilotMiniWidgets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
